import { apiWithAuth } from './api';

export const getNotifications = async (unreadOnly = false) => {
  const token = localStorage.getItem('token');
  const response = await apiWithAuth(token).get('/notifications/', {
    params: { unread_only: unreadOnly }
  });
  return response.data;
};

export const getUnreadNotificationCount = async () => {
  const token = localStorage.getItem('token');
  const response = await apiWithAuth(token).get('/notifications/unread/count');
  return response.data.unread_count;
};

export const markNotificationAsRead = async (notificationId) => {
  const token = localStorage.getItem('token');
  const response = await apiWithAuth(token).put(`/notifications/${notificationId}/read`);
  return response.data;
};

export const markAllNotificationsAsRead = async () => {
  const token = localStorage.getItem('token');
  const response = await apiWithAuth(token).put('/notifications/read-all');
  return response.data;
};


